<template>
  <div>
    <template v-if="isBatch">
      <div v-if="$has('FWS-KJSH-FKTK-TGBH')">
        <el-button
          type="success"
          icon="el-icon-success"
          :size="formSize"
          :disabled="!multipleSelection || multipleSelection.length===0"
          @click="handleOperateState(true,1)"
        >
          批量通过
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-delete-solid"
          :size="formSize"
          :disabled="!multipleSelection || multipleSelection.length===0"
          @click="handleOperateState(true,2)"
        >
          批量驳回
        </el-button>
      </div>
    </template>
    <template v-else>
      <div v-if="([1, '1'].includes(current.status) || [1, '1'].includes(current.approvalStatus)) && $has('FWS-KJSH-FKTK-TGBH')">
        <el-button
          class="table-button table-button-success"
          icon="el-icon-success"
          @click="handleOperateState(false, 1, current)"
        >通过</el-button>

        <el-button
          class="table-button table-button-danger"
          icon="el-icon-delete-solid"
          @click="handleOperateState(false, 2, current)"
        >驳回</el-button>
      </div>
    </template>
    <!-- 确认/取消确认弹窗 -->
    <jr-operate-dialog
      :visible.sync="isOperateStateShow"
      :data-obj.sync="refundObj"
      :text-config.sync="textConfig"
      :totalInfo.sync="totalInfo"
      :loading="submitLoading"
      @submit="opStateResultsSubmit"
    />
  </div>
</template>

<script>
import { setPayRefundBatchApproval } from '@/api/approval/refund';
import { add } from 'mathjs';

export default {
  props: {
    current: {
      type: Object,
      default: () => ({}),
    },
    type: {
      type: String,
      default: '1',
    },
    multipleSelection: {
      type: Array,
      default: () => ([]),
    },
    isBatch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      refundObj: {}, // 退款审核对象
      textConfig: {}, // 弹窗页面提示文案
      isOperateStateShow: false, // 确认/驳回弹窗
      submitLoading: false,
      // 批量操作合并信息
      totalInfo: {
        totalNum: 0, // 合计数量
        totalAmount: 0, // 合计金额
      },
    };
  },
  methods: {
    // 批量确认/驳回操作
    handleOperateState(batch, operation, row = {}) {
      const refundNos = (this.multipleSelection || []).map((item) => item.refundNo);
      const batchRefundNo = refundNos.length ? (refundNos).join(',') : '';
      this.refundObj = {
        refundNos: batch ? batchRefundNo : row?.refundNo || '',
        operation, // 操作：1、通过 2、驳回
        cancelRemark: '', // 驳回原因，驳回时必传
      };
      let list = {
        1: {
          title: '审核通过确认',
          messageTip: '是否通过该笔退款申请？',
          isPass: true,
        },
        2: {
          title: '审核驳回',
          messageTip: '驳回原因',
          isPass: false,
          required: true,
        },
      };
      if (batch) {
        list = {
          1: {
            title: '批量审核通过确认',
            messageTip: '是否批量审核通过所有被选中的退款申请？',
            isPass: true,
            isBatch: true,
            isTotal: true,
          },
          2: {
            title: '批量审核驳回',
            messageTip: '批量驳回原因',
            isPass: false,
            isBatch: true,
            isTotal: true,
            required: true,
          },
        };
      }
      let totalAmount = row.refundAmount ?? 0;
      if (batch) {
        // 合计金额
        totalAmount = (this.multipleSelection.map((item) => item.refundAmount || 0) || []).reduce((prev, cur) => {
          return add(prev, cur);
        });
        this.totalInfo = {
          totalNum: this.multipleSelection.length || 0, // 合计数量
          totalAmount,
        };
      }
      this.textConfig = list[operation] || '-';
      this.isOperateStateShow = true;
    },
    // 退款审核列表-退款批量审核操作+退款审核操作请求接口
    opStateResultsSubmit(params) {
      this.submitLoading = true;
      setPayRefundBatchApproval(params).then((res) => {
        console.log(res);
        this.submitLoading = false;
        this.$message({
          message: '操作成功！',
          type: 'success',
        });
        this.isOperateStateShow = false;
        this.$emit('success');
      }).catch(() => {
        this.submitLoading = false;
      });
    },
  },
};
</script>
